document.addEventListener("DOMContentLoaded", function () {
	const widget = document.getElementById("cf-sitekey");
	const submitButton = document.getElementById("edge_registration_submit");

	if (!widget || !submitButton) {
		return;
	}

	function enableSubmitButton() {
		submitButton.removeAttribute("disabled");
	}

	function disableSubmitButton() {
		submitButton.setAttribute("disabled", "disabled");
	}

	function renderTurnstile() {
		window.turnstile.render(widget, {
			sitekey: widget.getAttribute("data-sitekey"),
			callback: enableSubmitButton,
			"expired-callback": disableSubmitButton,
			"error-callback": disableSubmitButton,
		});
	}

	// api.js is third-party and may not have executed by DOMContentLoaded, so wait for the
	// global rather than throwing a ReferenceError on `turnstile`.
	let attempts = 0;
	(function waitForTurnstile() {
		if (window.turnstile && typeof window.turnstile.render === "function") {
			renderTurnstile();
			return;
		}

		attempts++;
		if (attempts > 100) {
			return;
		}

		window.setTimeout(waitForTurnstile, 100);
	})();
});
